import type { TestCaseRecord } from "@/types/api/TestCaseRecord"
import { escapeCsvValue } from "@/utils/csv/csv-formatter"

const TEST_SET_CSV_HEADERS = [
  "Input",
  "Expected Output",
  "Type",
  "Created At",
  "ID",
]

type ExportableTestSetRecord = Pick<
  TestCaseRecord,
  "created_at" | "expected_behaviors" | "id" | "input_str" | "input_type"
>

export function buildTestSetCsvContent(
  records: ExportableTestSetRecord[],
): string {
  const rows = records.map((record) => [
    escapeCsvValue(record.input_str || ""),
    escapeCsvValue((record.expected_behaviors ?? []).join(" • ")),
    escapeCsvValue(record.input_type || ""),
    escapeCsvValue(record.created_at || ""),
    escapeCsvValue(record.id || ""),
  ])

  return [
    TEST_SET_CSV_HEADERS.join(","),
    ...rows.map((row) => row.join(",")),
  ].join("\n")
}
